import { unitMapping } from '#src/lib/style.ts';

type Props = {
  size?: keyof typeof unitMapping;
  className?: string;
};

export const BaseballSecondBase = ({ size = 2, className }: Props) => (
  <svg
    className={className}
    style={{ width: unitMapping[size], height: unitMapping[size] }}
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.97511 8.78777L4.65828 9.05824L4.59646 9.42917H7.16977L6.96112 10.6347H3.02002L3.37549 8.58686L4.31826 7.78318L5.90243 7.43544L6.21154 7.1727L6.28881 6.74768L6.14972 6.5854H5.17603L4.58873 7.08769L3.80824 6.14492L4.71237 5.37988H7.03067L7.73388 6.23765L7.4866 7.63636L6.55155 8.4323L4.97511 8.78777ZM12.9779 6.26856L12.777 7.44316L12.2128 7.91455L12.7306 8.54822L12.5219 9.746L11.4787 10.6347H7.76944L8.69676 5.37988H12.2515L12.9779 6.26856ZM11.1542 7.45862L11.4246 7.23452L11.5096 6.7554L11.3628 6.5854H9.87136L9.72454 7.45862H11.1542ZM11.2237 9.22825L11.301 8.80323L11.0923 8.54822H9.53135L9.37679 9.42917H10.9841L11.2237 9.22825Z"
      fill="white"
    />
  </svg>
);
